<list-chips *ngIf="chipsView" />
<div class="new-filters-modal" [hidden]="chipsView">
  <div class="title__wrapper">
    <span class="title">{{ 'List.Filters.filters' | translate }}</span>
    <svg-icon class="clear-icon" [src]="'/assets/img/close-icon.svg'" (click)="cancel()" />
  </div>
  <div class="rows__wrapper">
    <div class="new-filters-modal__row">
      <list-single-filter-select-v2
        class="w-100"
        *ngIf="
          employee?.role === UserRoles.ROLE_EMPLOYEE_ADMIN ||
          employee?.role === UserRoles.ROLE_EMPLOYEE_MANAGER ||
          employee?.hasResponsibleProjects
        "
        [name]="'ProjectsList.Filters.responsibleCompany' | translate"
        [iconUrl]="'/assets/img/ic-person-circle-outline.svg'"
        [form]="service?.filtersForm"
        [controlName]="'[responsibleEmployee-id][eq]'"
        (change)="onChangeFilter()"
        [searchGetParams]="'search'"
        [requiredIdUrl]="Config.API + '/employee/search?' + searchRoles"
        [valueTransform]="creatorName.bind(this)"
        [sortByField]="'created'"
        (selectedValues)="handleSelectedValues($event, '[responsibleEmployee-id][eq]')"
      />

      <list-single-filter-select-v2
        class="w-100"
        [name]="'ProjectsList.Filters.client' | translate"
        [iconUrl]="'/assets/img/ic-person-circle-outline.svg'"
        [form]="service?.filtersForm"
        [controlName]="'[mainContact-id][in]'"
        [multiple]="true"
        (change)="onChangeFilter()"
        [requiredIdUrl]="Config.API + '/contact/search'"
        [valueTransform]="contactName.bind(this)"
        [responseTransform]="responseTransform.bind(this)"
        [sortByField]="'created'"
        (selectedValues)="handleSelectedValues($event, '[mainContact-id][in]')"
      />
    </div>

    <div class="new-filters-modal__row">
      <div class="w-100">
        <div class="new-select-label">{{ 'ProjectsList.Filters.created' | translate }}</div>
        <daterangepicker-v2
          #daterangepicker
          [form]="service?.filtersForm"
          [controlStart]="'[a-created][gte]'"
          [controlEnd]="'[a-created][lte]'"
          [title]="'ProjectsList.Filters.created' | translate"
          (rangeChanged)="onChangeFilter()"
        />
      </div>

      <list-single-filter-select-v2
        class="w-100"
        [name]="'ProjectsList.Filters.projectStage' | translate"
        [iconUrl]="'/assets/img/ic-person-circle-outline.svg'"
        [form]="service?.filtersForm"
        [controlName]="'[a-stage][in]'"
        bindLabel="name"
        bindValue="id"
        [multiple]="true"
        [localItems]="stages"
        (change)="onChangeFilter()"
        (selectedValues)="handleSelectedValues($event, '[a-stage][in]')"
      />
    </div>

    <div class="new-filters-modal__row">
      <list-single-filter-select-v2
        class="w-100"
        [name]="'ProjectsList.Filters.propertyType' | translate"
        [iconUrl]="'/assets/img/ic-home.svg'"
        [form]="service?.filtersForm"
        [localItems]="propertyTypes"
        [bindValue]="'id'"
        [bindLabel]="'name'"
        [controlName]="'[basicDataBox-propertyType][eq]'"
        [multiple]="true"
        (change)="onChangeFilter()"
        (selectedValues)="handleSelectedValues($event, '[basicDataBox-propertyType][eq]')"
      />
    </div>

    <list-single-filter-toggle
      [name]="'ProjectsList.Filters.showRemoved' | translate"
      [form]="service?.filtersForm"
      [controlName]="'[deleted]'"
      (change)="onChangeFilter()"
    />
  </div>

  <div class="buttons">
    <list-single-clear-filters-v2
      [form]="service?.filtersForm"
      (change)="onChangeFilter()"
      [shouldShowClearFilters]="shouldShowClearFilters.bind(this)"
      [clearFilters]="clearFilters.bind(this)"
    />

    <div class="buttons__inside">
      <app-button
        [type]="'button'"
        (onClick)="cancel()"
        [config]="{
          size: ButtonSize.LARGE,
          smSize: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
          text: 'DATERANGEPICKER.cancelBtn' | translate
        }"
      />

      <app-button
        [type]="'button'"
        [disabled]="loading"
        [loading]="loading"
        (onClick)="submit()"
        [config]="{
          size: ButtonSize.LARGE,
          smSize: ButtonSize.SMALL,
          type: ButtonTypes.NEW_PRIMARY_BLUE,
          text: 'DATERANGEPICKER.acceptBtn' | translate,
          prependSrc: './assets/img/tick-icon.svg'
        }"
      />
    </div>
  </div>
</div>
